import { useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { PixKeyType } from '../../enums';
import { useLazyGetPixKeyQuery } from '../../services/pixKeysApi';
import { formatAsRegionalPhoneCode } from '../../utils/pixFormatters';
export function useGetPixKey() {
    const { t } = useTranslation();
    const [trigger] = useLazyGetPixKeyQuery();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [pixKey, setPixKey] = useState();
    async function getPixKey(key, type, rethrow) {
        setLoading(true);
        setError(undefined);
        setPixKey(undefined);
        try {
            const { data } = await trigger(type === PixKeyType.PHONE ? formatAsRegionalPhoneCode(key) : key, false);
            if (!data?.result) {
                throw new Error(t('can-not-find-the-pix-key'));
            }
            else {
                setPixKey(data.result);
                return data.result;
            }
        }
        catch (err) {
            setError(t('can-not-find-the-pix-key'));
            if (rethrow) {
                throw err;
            }
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        pixKey,
        setPixKey,
        getPixKey,
    };
}
